/**
 * @generated SignedSource<<24bf6b2d5369a9f04d76d300209ba275>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Row_row$data = {
  readonly id: string;
  readonly text: string;
  readonly " $fragmentType": "Row_row";
};
export type Row_row$key = {
  readonly " $data"?: Row_row$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row_row">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Row_row",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "RowNode",
  "abstractKey": null
};

(node as any).hash = "2cac74967dbae7c7ef497bb48a5652e4";

export default node;
